import AvatarFallback from "./AvatarFallback";
import React from 'react';
import { Box, List, ListItem, ListItemIcon, Typography } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import Like from "@mui/icons-material/ThumbUpOutlined";
import Comment from "@mui/icons-material/ChatBubbleOutline";
import SendIcon from '@mui/icons-material/Send';
import RepeatIcon from '@mui/icons-material/Repeat';
import "./style.css";

const LinkedIn = ({ selectedAccounts, formattedTags, accResp, selectedImages, selectedIndex, avatars, postText }) => {
    const numImages = selectedImages.length;

    // LinkedIn grid layout configurations
    const getGridStyle = () => {
        if (numImages === 1) {
            return {
                gridTemplateColumns: "1fr",
                gridTemplateRows: "1fr",
            };
        }
        if (numImages === 2) {
            return {
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "1fr",
            };
        }
        if (numImages === 3) {
            return {
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "1fr 1fr",
            };
        }
        return {
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr",
        };
    };
    return (
        <Box className="tab-pane h-full">
            <Box className="user-container p-10 relative mx-5">
                {selectedAccounts === undefined || selectedAccounts.length === 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px' }}>
                        <Box sx={{ width: '50px', height: '50px', borderRadius: '50%', backgroundColor: 'var(--background-preview)', flexShrink: 0 }} />
                        <Box sx={{ flex: 1 }}>
                            <Box style={{ width: '35%', height: '13px', backgroundColor: 'var(--background-preview)', marginBottom: '6px', borderRadius: '4px' }} />
                            <Box style={{ width: '55%', height: '11px', backgroundColor: 'var(--background-preview)', marginBottom: '6px', borderRadius: '4px' }} />
                            <Box style={{ width: '25%', height: '11px', backgroundColor: 'var(--background-preview)', borderRadius: '4px' }} />
                        </Box>
                    </Box>
                ) : (
                    <>
                        {selectedAccounts.map((id, i) => {
                            const index = accResp.findIndex((acc) => acc.id === id);
                            const avatar = avatars[index];
                            const userName = accResp[index].username;

                            return (
                                <Box
                                    key={id}
                                    sx={{
                                        display: i === selectedIndex ? 'flex' : 'none',
                                        alignItems: 'flex-start',
                                        gap: '12px',
                                        marginBottom: '12px',
                                    }}
                                >
                                    <AvatarFallback
                                        src={avatar}
                                        name={userName}
                                        background="#0a66c2"
                                        style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                        fallbackStyle={{ flexShrink: 0 }}
                                    />
                                    <Box sx={{ flex: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Typography sx={{ color: 'var(--text-color)', fontWeight: 700, fontSize: '15px', lineHeight: 1.3 }}>{userName}</Typography>
                                            <Typography sx={{ color: '#0a66c2', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>• Follow</Typography>
                                        </Box>
                                        <Typography sx={{ color: '#666', fontSize: '13px', lineHeight: 1.3 }}>Social Media Manager</Typography>
                                        <Typography sx={{ color: '#666', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            1h • <PublicIcon sx={{ fontSize: '14px' }} />
                                        </Typography>
                                    </Box>
                                    <MoreHoriz sx={{ color: '#666', cursor: 'pointer' }} />
                                </Box>
                            );
                        })}
                    </>
                )}
            </Box>
            <Box className="mt-3">
                <Box className="text-container mb-4 mt-3" style={{
                    placeItems: 'flex-start',
                    width: '100%',
                }}>
                    {postText === undefined || postText === '' ? (
                        <>
                            <Box style={{ width: '100%', height: '12px', backgroundColor: 'var(--background-preview)', marginBottom: '5px' }}></Box>
                            <Box style={{ width: '100%', height: '12px', backgroundColor: 'var(--background-preview)', marginBottom: '5px' }}></Box>
                            <Box style={{ width: '100%', height: '12px', backgroundColor: 'var(--background-preview)', marginBottom: '5px' }}></Box>
                        </>
                    ) : (
                        <>
                            <Typography component="div"
                                style={{
                                    whiteSpace: 'pre-wrap',
                                    overflow: 'hidden',
                                    marginBottom: '5px',
                                    color: 'var(--text-color)',
                                    fontSize: '14px',
                                    lineHeight: '1.5'
                                }}>
                                {postText}
                            </Typography>
                            <Typography component="div"
                                style={{
                                    whiteSpace: 'pre-wrap',
                                    overflow: 'hidden',
                                    marginBottom: '5px',
                                    color: '#0a66c2'
                                }}>
                                {formattedTags}
                            </Typography>
                        </>
                    )}
                </Box>
            </Box>
            {numImages > 0 && (
                <Box className="flex justify-center">
                    <Box
                        className="media-preview linkedin-gallery"
                        style={{ width: "523px", height: "auto", maxHeight: "523px" }}>
                        <Box
                            className="linkedin-gallery-grid"
                            style={{
                                display: "grid",
                                gap: "2px",
                                ...getGridStyle(),
                                position: "relative",
                            }}>
                            {numImages === 1 ? (
                                <img
                                    src={selectedImages[0].props.src}
                                    alt=""
                                    style={{
                                        width: "100%",
                                        height: "523px",
                                        objectFit: "cover",
                                        borderRadius: "0",
                                    }}
                                />
                            ) : numImages === 2 ? (
                                selectedImages.slice(0, 2).map((image, index) => (
                                    <img
                                        key={index}
                                        src={image.props.src}
                                        alt=""
                                        style={{
                                            width: "100%",
                                            height: "350px",
                                            objectFit: "cover",
                                        }}
                                    />
                                ))
                            ) : numImages === 3 ? (
                                <>
                                    <img
                                        src={selectedImages[0].props.src}
                                        alt=""
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            gridRow: "1 / 3",
                                        }}
                                    />
                                    {selectedImages.slice(1, 3).map((image, index) => (
                                        <img
                                            key={index + 1}
                                            src={image.props.src}
                                            alt=""
                                            style={{
                                                width: "100%",
                                                height: "175px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ))}
                                </>
                            ) : (
                                <>
                                    {selectedImages.slice(0, 4).map((image, index) => (
                                        <Box
                                            key={index}
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                height: "175px",
                                            }}>
                                            <img
                                                src={image.props.src}
                                                alt=""
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            {index === 3 && numImages > 4 && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}>
                                                    <Typography
                                                        sx={{
                                                            color: "#fff",
                                                            fontSize: "36px",
                                                            fontWeight: "bold",
                                                        }}>
                                                        +{numImages - 4}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
            )}
            <Box className="preview-footer flex justify-center">
                <List sx={{ display: 'flex', alignItems: 'center', padding: 2 }}>
                    {[
                        { icon: <Like sx={{ color: 'var(--text-color)' }} />, label: 'Like' },
                        { icon: <Comment sx={{ color: 'var(--text-color)' }} />, label: 'Comments' },
                        { icon: <RepeatIcon sx={{ color: 'var(--text-color)' }} />, label: 'Share' },
                        { icon: <SendIcon sx={{ color: 'var(--text-color)', transform: 'rotate(-45deg)' }} />, label: 'Send' }
                    ].map(({ icon, label }) => (
                        <ListItem key={label} sx={{ fontSize: '20px', color: '#1e7594', display: 'flex', alignItems: 'center' }}>
                            <ListItemIcon>
                                {icon}
                            </ListItemIcon>
                            <Typography variant="body1">{label}</Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default LinkedIn;
